var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafetyBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.15 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#263d50;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Biztons\\xE1g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.87,23.46V56.11A4.89,4.89,0,0,1,46,61H5.89A4.89,4.89,0,0,1,1,56.11V23.46a.79.79,0,0,1,.78-.79H50.09A.79.79,0,0,1,50.87,23.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.42,18.71V16.52a15.52,15.52,0,1,1,31,0v6.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,18.71v-.86a7.95,7.95,0,0,1,15.89,0v4.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.13,47.54v-3a6.32,6.32,0,1,1,7.61,0V51H22.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "54.08 9.9 51.43 12.55 48.77 9.9 45.69 6.82 48.35 4.16 51.43 7.24 57.08 1.59 59.74 4.24 54.08 9.9 51.43 12.55 48.77 9.9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyBlack);
export default __webpack_public_path__ + "static/media/safetyBlack.2fe13707e28f49efc2c086fb9199e19a.svg";
export { ForwardRef as ReactComponent };